import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=458629c8&"
import script from "./context-menu.vue?vue&type=script&lang=js&"
export * from "./context-menu.vue?vue&type=script&lang=js&"
import style0 from "./context-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "context-menu.vue"
export default component.exports